import { createRoot } from "react-dom/client";
// Apps
import "./_metronic/assets/keenicons/duotone/style.css";
import "./_metronic/assets/sass/style.scss";
import "./_metronic/assets/sass/plugins.scss";
import "./_metronic/assets/sass/style.react.scss";
import "cpl-react-common/Helpers/DateExtensions";
import "cpl-react-common/Helpers/NumberExtensions";
import { AppRoutes } from "./app/routing/AppRoutes";
import { Provider } from "react-redux";
import store, { persistor } from "./setup/redux/Store";
import { PersistGate } from "redux-persist/integration/react";

import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { AppErrorBoundary } from "app/modules/errors/AppErrorBoundary";
import { reloadOnChunkLoadError } from "cpl-react-common/Helpers/reloadOnChunkLoadError";

window.addEventListener("vite:preloadError", (event) => {
  reloadOnChunkLoadError(event);
});

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <AppErrorBoundary>
    <Provider store={store}>
      <PersistGate persistor={persistor} loading={<div>Loading...</div>}>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
          limit={3}
        />
        <AppRoutes />
      </PersistGate>
    </Provider>
  </AppErrorBoundary>
);
